export enum WINDOW_WIDTH {
   sm = 540,
   md = 720,
   lg = 960,
   xl = 1200 
}